import { Column } from 'components/Layout/grid/Column';
import { Row } from 'components/Layout/grid/Row';
import { ElementLink } from 'components/Layout/Link';
import mixins, { device } from 'components/styles/mixins';
import { bbTheme } from 'components/styles/theme';
import Title from 'components/styles/Title';
import Image from 'next/image';
import React from 'react';
import { Article } from 'src/types/sanity/schema';
import styled from 'styled-components';
import { urlFor } from 'utils/sanity/sanity';
import { convertRems } from 'utils/stringFunctions';
import { journalTitle } from './ArticleMeta';
import { defaultImageLoader } from './helperFunctions';

const PaginationStyles = styled(Row)`
    border-bottom: ${({ theme }) => theme.borders.base};
    padding: 0 ${({ theme }) => theme.spacing.gutter};
    .column-wrapper a {
        ${mixins.flex}
        .pagination-image {
            object-fit: cover;
        }
    }

    .text {
        margin: ${({ theme }) => theme.spacing.m};
        margin-left: ${({ theme }) => theme.spacing.xs};
    }
    .column-1 {
    }
    .column-2 {
        padding: 0;
        ${mixins.flex}
    }

    .column-3 {
        @media ${device().medium} {
            .text {
                order: 1;
            }
        }
    }
`;
interface PaginationProps {
    prevArticle?: Article;
    nextArticle?: Article;
}

const Pagination: React.FC<PaginationProps> = ({ prevArticle, nextArticle }) => {
    const { small, medium, large } = bbTheme.breakpoints;
    const { xs } = bbTheme.spacing;
    const {
        title: prevtitle,
        mainImage: prevMainImage,
        body: prevbody,
    } = prevArticle || {
        title: '',
        mainImage: '',
        body: {},
    };

    const {
        title: nexttitle,
        mainImage: nextMainImage,
        body: nextbody,
    } = nextArticle || {
        title: '',
        mainImage: '',
        body: {},
    };

    const prevFeaturedImage = urlFor(prevMainImage).url();
    const nextFeaturedImage = urlFor(nextMainImage).url();

    return (
        <PaginationStyles className="Pagination-container" spacing={[0, convertRems(xs)]} breakpoints={[medium, large]}>
            {prevArticle && (
                <Column widths={[4, 4]}>
                    <ElementLink hrefProp={`${prevArticle.slug}`}>
                        {prevFeaturedImage && (
                            <Image
                                className="pagination-image  prev-image"
                                layout="intrinsic"
                                width={100}
                                height={180}
                                src={prevFeaturedImage}
                                alt={prevtitle}
                                loader={defaultImageLoader}
                            />
                        )}

                        <div className="text">
                            <p className="aside">Previous Story</p>
                            <Title as="h5">{journalTitle(prevArticle.title || '')}</Title>
                        </div>
                    </ElementLink>
                </Column>
            )}
            <Column widths={[4, 4, 4]}></Column>
            {nextArticle && (
                <Column widths={[4, 4]}>
                    <ElementLink hrefProp={`${nextArticle.slug}`}>
                        <div className="text">
                            <p className="aside">Next Story</p>
                            <Title as="h5">{journalTitle(nextArticle.title || '')}</Title>
                        </div>
                        {nextFeaturedImage && (
                            <Image
                                className="pagination-image  next-image"
                                width={100}
                                height={180}
                                src={nextFeaturedImage}
                                alt={nexttitle}
                                loader={defaultImageLoader}
                            />
                        )}
                    </ElementLink>
                </Column>
            )}
        </PaginationStyles>
    );
};

export default Pagination;
